"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_jss_1 = require("react-jss");
var menuTriggerIcon_svg_1 = __importDefault(require("./menuTriggerIcon.svg"));
var classnames_1 = __importDefault(require("classnames"));
var defaultProps = {
    open: false,
};
var useStyles = (0, react_jss_1.createUseStyles)(function (_a) {
    var colors = _a.colors, borderRadius = _a.borderRadius;
    return ({
        open: {},
        trigger: {
            borderRadius: borderRadius.sm,
            userSelect: 'none',
            background: 'none',
            border: 'none',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            width: 'inherit',
            height: 'inherit',
            '&:hover': {
                backgroundColor: colors.Grey[100],
            },
            '$open &': {
                extend: 'activeTrigger',
            },
        },
        active: {
            backgroundColor: colors.Hannibal[100],
        },
    });
});
var DropdownMenuTrigger = function (_a) {
    var _b;
    var component = _a.component, open = _a.open, onClick = _a.onClick;
    var styles = useStyles();
    if (component && (0, react_1.isValidElement)(component)) {
        var customTrigger = (0, react_1.cloneElement)(component, { onClick: onClick, open: open });
        return react_1.default.createElement(react_1.default.Fragment, null, customTrigger);
    }
    return (react_1.default.createElement("button", { onClick: onClick, "aria-label": "Toggle menu", className: (0, classnames_1.default)(styles.trigger, (_b = {}, _b[styles.active] = open, _b)) },
        react_1.default.createElement("img", { src: menuTriggerIcon_svg_1.default, alt: "Toggle menu" })));
};
DropdownMenuTrigger.defaultProps = defaultProps;
exports.default = DropdownMenuTrigger;
//# sourceMappingURL=DropdownMenuTrigger.js.map